import { InlineText3 } from '@cian/ui-kit';
import { Select } from '@cian/ui-kit/select';
import * as React from 'react';
import { IFormattedPeriod } from '../../../../redux/reducers';
import * as styles from './PlacingPeriod.mobile.css';

interface IPlacingPeriodMobileProps {
  activePeriodId: string | null;
  periods: IFormattedPeriod[];
  hint: string | null;
  onChangePeriod(newPeriodId: string): void;
}

export const PlacingPeriodMobile = ({ activePeriodId, periods, hint, onChangePeriod }: IPlacingPeriodMobileProps) => {
  return (
    <div className={styles['wrapper']}>
      <Select value={activePeriodId} options={periods} placeholder="Срок размещения" onChange={onChangePeriod} />

      {hint && (
        <div className={styles['hint']}>
          <InlineText3 color={'gray60_100'}>{hint}</InlineText3>
        </div>
      )}
    </div>
  );
};
